import { client } from "../../client";

export const TICKET_STATUSES = ["Open", "Closed", "Cancelled", "Error"];
export type TicketStatus = typeof TICKET_STATUSES[number];

export const TICKET_PRIORITIES = [
  "Low",
  "Medium",
  "High",
  "Critical",
  "Major",
  "Minor",
];

export type TicketPriority = typeof TICKET_PRIORITIES[number];

export const DUE_STATUSES = ["NoDueDttm", "Overdue", "NearDue", "OK"];
export type DueStatus = typeof DUE_STATUSES[number];

export type TicketInfo = {
  id: string;
  raisedDttm: string;
  dueDttm: string | null;
  dueStatus: DueStatus;
  team: string | null;
  user: string | null;
  summary: string;
  status: TicketStatus;
  step: string;
  priority: TicketPriority;
  code: string;
  name: string;
};

export const getAccountTickets = (
  queryKey: string,
  {
    status,
    accountNumber,
  }: {
    status: string;
    accountNumber?: string;
  },
): Promise<TicketInfo[] | undefined> => {
  const params = { status };
  return client
    .get<{
      results: TicketInfo[];
    }>(
      `accounts/${accountNumber}/tickets?${new URLSearchParams(
        params,
      ).toString()}`,
    )
    .then((response) => response?.data?.results);
};
